module.exports = {
  title: '道琼斯黑名单查询系统',
  Welcome: '欢迎',
  Pleaseinputcontents: '请输入内容',
  Exitfail: '退出失败',
  Loadfailure: '加载失败',
  LastUpdateTime: '最近更新时间',
  Update: '更新',
  UTpromptcontent: '更新数据需要收费,是否需要更新？',
  cancel: '取消',
  confirm: '确认',
  close: '关闭',
  PleaseChoose: '请选择',
  MonitoringCycle: '监控周期',
  ArgumentsCannotBeEmpty: '参数不能为空',
  MonitorHint: '监控该企业将会产生费用，是否确认继续添加？',
  success: '成功',
  refresh: '刷新',
  layuiModeltitle: '信息提示',
  layuiModelconfirm: '确认',
  login: '点击登录',
  Regain: '重新获取',
  PersonalCenter: '个人中心',
  ReturnHomepage: '返回首页',
  SignOut: '退出',
  titlename: '数据e网打尽，用户智能识别',
  PRC: '中国大陆企业',
  GlobalCheck: '全球黑名单识别',
  NonPRC: '中国港澳台地区及海外企业',
  Advanced: '高级筛查',
  searchPlaceholder: '请输入企业名称或统一社会信用代码或工商登记号',
  FEnterfullameEnterprise: '请输入企业全称',
  ChooseCountryOfEnterprise: '企业所在国家',
  PersonalORorganizationName: '请输入个人或组织名称',
  SpecificName: '请输入实体详细名称',

  Serial: '序号',
  Age: '年龄',
  Gender: '性别',
  View: '查看',
  Former: '变更前',
  Later: '变更后',

  // pageFooter
  Contact: '如需更多服务及支持请联系',
  Telephone: '客服热线：0571-26695555 转7',
  QQ: '客服QQ',
  // Email: '客服邮箱',

  loginKYC: ' 道琼斯黑名单查询系统大数据账号登陆',
  ObtainCode: ' 获取验证码',
  telPlaceholder: '请输入手机号',
  VerificationCode: '请输入验证码',
  Password: '请输入密码',
  PasswordAgain: '再次输入密码',
  NewPassword: '请输入新密码',
  NewPasswordAgain: '再次输入新密码',
  ResetPassword: '重置密码',
  LoginByPassword: '密码登录',
  LoginByCode: '验证码登录',
  SignIn: '立即登录',
  SignUp: '注 册',
  NotSame: '密码不一致',
  Company: '请输入所属公司名称',
  ImageStr: '请输入以下图片中的字符',
  Refresh: '看不清楚，请换一张',
  SMS_Code: '短信验证码',
  Voice_Code: '语音验证码',
  PhoneOrCodeIsNull: '手机号或验证码为空',
  PasswordOrCodeIsNull: '密码或验证码为空',

  // 提示 tip
  TipPwdFormat: '6-20位，必须包含大小写字母、特殊字符、数字中的三种!',
  TipPwdFormatError: '长度为6-20位，必须包含大小写字母、特殊字符、数字中的三种，且不能包含空格!',
  TipPhoneFormatError: '手机号为空或非法！',

  SearchResult: '<strong>道琼斯黑名单查询系统</strong>为您找到以下<span style="color: red;">相关</span>的公司',
  LegalPerson: '法人代表',
  BusinessNumber: ' 统一社会信用代码',

  FormerName: '曾用名',
  phone: '电话',
  Email: '邮箱',
  Address: '地址',
  CompanyMap: '企业图谱',
  MacroAttach: '资本系',
  CompanyMapExplain: '企业信息一图掌控',
  MacroAttachExplain: '资本系信息详尽掌握',
  UpdatedTime: '更新时间',
  QueriedTimes: '查询次数',
  updataData: '更新数据',
  Monitor: '加入监控',
  ViewMonitor: '查看监控',
  ReportDownload: '下载报告',
  WaitForProgram: '正在开发中，请期待~',
  UpdatedTimes: '更新次数',
  Thisupdate: ' 本次更新',
  Basics: '基本信息',
  Risks: '综合风险',
  intellectualProperty: '知识产权',
  publicSentiment: '企业舆情',
  FinancialStatements: '财务报表',
  MacroEvent: '宏观事件',
  opinionEvents: '舆情事件',

  LegalPersoninformation: '法定代表人信息',
  CompanyInvestment: '企业对外投资',
  EquityStructure: '企业无限股权穿透',
  PersonalDiagramMap: '查看人物图谱',
  Details: '查看详情',
  ComingSoon: '敬请期待',

  //  股权穿透-证券信息
  SecurityInformation: '证券信息',
  StockCode: '股票代码',
  StockAbbreviation: '股票简称',
  StockMarket: '股票市场',
  StockPlate: '所属板块',
  ListingDate: '上市日期',
  StockValue: '股票市值',
  PERatio: '市盈率',
  PBRatio: '市净率',

  RegisteredInformation: '工商信息',
  RegisteredCapital: '注册资本',
  RegisteredDate: '成立日期',
  UniformSocialCreditCode: '统一社会信用代码',
  ConfirmedDate: '核准日期',
  OperationPeriod: '营业期限',
  Domicile: '企业地址',
  BusinessScope: '经营范围',
  TaxpayerIdentificationNumber: '纳税人识别号',
  ConpanyType: '公司类型',
  RegistrationAuthority: '登记机关',

  Shareholders: '股东信息',
  ShareholderName: '股东',
  Status: '状态',
  INSTO: '持股比例',
  SubscribedCapital: '认缴出资额（万元）',
  CAT: '股东类型',
  SubscribedDate: '认缴出资日期',
  Relation: '关联关系',

  NorelatedInformation: '暂无相关信息，看看该公司的其他信息',
  statusDetails: ' 详情',

  MOLandCR: '工商登记主要人员',
  BlackListFlag: '特定自然人标志',

  MainOfficerInformation: '上市公告主要人员',
  MOIPosition: '职务',
  MOIPositionStartDate: '任职起始日期',
  MOIPositionEndDate: '任职结束日期',
  MOIRelation: '关联/关系',

  AlterationBusiness: '工商变更',
  Changedate: '变更日期',
  ChangeProject: '变更项目',
  BeforetheChange: '变更前',
  AftertheChange: '变更后',

  Branch: '分支机构',

  ShareholdingStructure: '股权穿透',
  Shareholder: '股东',
  SuspectedBeneficiary: '疑似受益所有人',
  Beneficiary: '持股受益人',
  Degree: '请选择显示层级',
  DefaultDegree: ' 默认显示5层',
  Tree: '树型',
  Form: ' 表单',

  SSEnterpriseName: '企业名称',
  SSConpanyType: '企业类型',
  Export: '导出',

  SSShareholderlevel: '股东层级',
  SSBusinessCode: '企业法人股东代码',
  SSShareholder: '股东名称',
  SSShareholderType: '股东类型',
  SSLegalPerson: '法人代表',
  SSShareholderStatus: '股东状态',
  SSINSTO: '持股比例',
  SSSubscribedCapital: '认缴金额(万元)',
  SSDeliveredCapital: '实缴金额(万元)',
  SSSuperiorshareholdercode: '上级股东代码',
  SSSuperiorInvestmentPath: '上级投资路径',
  SSriskType: '风险类型',
  SShumanFigures: '人物定义',

  ControlPath: '控制路径',
  SSConpanyStatus: '企业状态',
  SSOperationAbnormal: '是否异常经营',

  AdvancedScreening: '高级筛查',
  MassScreening: '批量筛查',

  PersonalPerson: '个体识别',
  PersonalOrganization: '实体识别',
  BatchPersonalPerson: '个体批量识别',
  BatchPersonalOrganization: '实体批量识别',
  PGlobalBlacklist: '全球黑名单识别',
  PCompanyInvestment: '企业对外投资',
  PExecutivesInvestment: '企业关联人对外投资',
  PNaturePersonInvestment: '自然人对外投资',
  CompanyNetwork: '企业关系',
  PFormType: '类型',
  PFormAll: '全部',
  PFormPerson: '个人',
  PFormOrganization: '机构',
  PFormName: '名称',
  PFormCName: '中文名称',
  PFormNameInput: '请输入用户详细名称',
  PFormGender: '性别',
  PFormMale: '男',
  PFormFemale: '女',
  PFormUnknown: '未知',
  PFormBirthday: '出生日期',
  PFormNationality: '所在国籍',
  CertificateType: '证件类型',
  CertificateCode: '证件号码',
  PFormCountryRegion: '国家/地区',
  PFormzhushi: '以上条件输入越全面，查询结果越精准',
  PFormChecking: '查询',
  StartCheck: '开始查询',

  // 个体、实体批量识别
  TaskName: '任务名称',
  TaskStatus: '任务状态',
  TotalCount: '查询总数(条)',
  HitCount: '命中(条)',
  MissCount: '未命中(条)',
  CreateTime: '创建时间',
  UpdateTime: '更新时间',
  Reset: '重置',
  Underway: '进行中',
  Finished: '已完成',
  TaskUnderway: '该任务正在进行中',
  TempletDownload: '下载模板',
  LimitTip: '只能上传excel文件，且不超过5M',
  Upload: '点击上传文件',
  Add: '新增',
  FirstTaskName: '请先输入任务名称',
  FirstUpload: '请上传文件',
  Deleted: '删除成功',
  ConfirmDelete: '确定要删除吗？',
  FirstSelect: '请先勾选任务',
  OnlySelectOne: '只能选择一条记录进行复审',
  EnterName: '请输入姓名',
  ChineseName: '中文姓名',

  EnterpriseInformation: '企业信息',
  EnterpriseInformationInput: '请输入企业名称/统一社会信用代码/注册号',

  EnterprisePersonName: '个人姓名',
  EnterprisePersonNameInput: '请输入该企业中个人的姓名',

  IDCardNumber: '身份证号码',
  IDCardNumberInput: '请输入身份证号码',

  //  worldcheck
  worldcheckListTitle: '道琼斯黑名单查询系统为您找到以下相关的信息',
  worldcheckName: '名称',
  worldcheckAlias: '别名',
  worldcheckGender: '性别',
  beforeMarriage: '婚前名',
  worldcheckBirthday: '出生日期',
  worldcheckNationality: '所在国籍',
  worldcheckCountryRegion: '所在国家/地区',
  worldcheckSubCategory: '风险子类',
  worldcheckCategory: '风险大类',
  worldcheckMore: '其他黑名单查询',
  customerType: '用户类型',
  ListClassification: '名单一级分类',
  SecondClassification: '名单二级分类',
  ThirdClassification: '名单三级分类',
  registrationDate: '出生/注册日期',
  IDNumber: '证件号码',
  worldcheckDeceased: '已故',
  worldcheckStatus: '状态',
  audit: '审核',
  ifSureToAudit: '您确定修改这条流水记录的状态吗？',

  worldcheckBasicInformation: '基本画像',
  worldcheckAdditionInformation: '更多信息',
  worldcheckCauseBlacklist: '列入风险名单原因',
  worldcheckKeywords: '关键字',
  worldcheckClickDetails: '点击查看详情',
  worldcheckSocialNetworks: '人物关联/关系',
  worldcheckIncidenceRelation: '关联/关系',

  worldcheckOrganization: '关联实体',
  worldcheckIndividual: '关联个人',

  WCPersonDetails: '用户详情',
  WCPosition: '职位',
  WCGender: '性别',
  WCNationality: '国籍',
  WCRegistrationTIme: '入库日期',
  WCTitle: '头衔',
  CountriesAndRegions: '国家/地区',
  WCBirthday: '出生日期',
  WCPlaceBirth: '出生地',
  WCUpdateTime: '最近更新日期',
  WCAddressMapInfo: '地址信息',
  WCAddressMap: '图谱',
  WCAddressFrom: '表单',
  UserImage: '头像URL',

  WCProfessionDetails: '职业信息',
  WCProfessionType: '职业类别',
  WCProfessionName: '职业名称',
  WCProfessionStartData: '起始日期',
  WCProfessionEndData: '截止日期',

  PersonalNameType: '名称类型',
  PersonalName: '名字',
  PersonalLastName: '姓氏',
  PersonalMiddleName: '中间名',

  SanctionsListName: '列入制裁名单名称',
  SanctionsStartData: '制裁起始日期',
  SanctionsEndData: '制裁终止日期',

  WCKeywords: '关键字',
  WCDescriptions: '说明',
  WCIssueCountry: '国家',
  City: '城市',
  Street: '街道',
  AddressURL: '地址URL',
  Confidence: '置信度',
  companyName: '公司名称',
  AssociationRelationshipType: '关联关系类型',
  AssociatedInstitutionName: '关联机构名称',
  AssociatedInstitutionPersonalName: '关联人姓名',
  CorrelationDescription: '关联关系描述',
  WCSocialNetworkDiagram: '关联/关系智能图谱',

  // 个人中心begin
  UserLevel: '等级：普通用户',
  PCMonitorEnterprise: '企业监控',
  PCMonitorIndividual: '个人监控',
  financialReport: '财务数据',
  PCAll: '全部',
  PCClearAll: '全部清空',
  MonitorList: '监控列表',
  MonitorResult: '监控结果',
  ManualVerification: '人工核对',
  ScreeningRecord: '筛查记录',
  AppliedList: '已申请企业',
  StatementDetails: '财务报表详情',
  FavorList: '历史收藏',
  QueryReport: '报告查询',
  CompanyUnderMonitor: '已成功添加企业监控列表',
  MonitorStartDate: '监控开始日期',
  MoniotrEndDate: '监控截止日期',
  MonitorStatus: '监控状态',
  MonitoringFrequency: '监控频率(天)',
  Day: '天',
  Renewal: '续期',
  QSY: '变更监控频率(天)',
  IndividualUnderMonitor: '已成功添加监控企业关联人列表',
  IndividualName: '个人姓名',
  AppliedCompanyList: '已成功申请财务数据的企业列表',
  MoreFinanceStatement: '添加申请',
  ApplyStatus: '申请状态',
  ListedStatus: '是否上市',
  List: '上市',
  Unlisted: '非上市',
  FinancialDataDate: '数据日期',
  ApplyNewFinance: '申请企业财务数据',
  InputNotNull: '输入不能为空',
  FinanceStatementDetails: '财务数据详情',
  PublicSentimentList: '已收藏企业舆情信息',
  SentimentTitle: '标题',
  AdditionDate: '收藏日期',
  InfoSource: '信息来源',
  Delete: '删除',
  NoCollectioninformation: '暂无收藏内容',
  // 个人中心end

  pLeaglPersonINVEST: '法人对外投资',
  PLeaglPersonServe: '法人其他公司任职',
  PCoINVEST: '企业对外投资',
  POPAbnormal: '经营异常',
  PADMPenalty: '行政处罚',
  PEquityPledge: '股权出质',
  PBranch: '分支机构',
  PEquityFrozen: '股权冻结',
  PAlteration: '工商变更',
  PLegalRIsk: '司法风险',

  PCMCategory: '监控类型',
  PCMECN: '新增/变更项目',
  PCMissueDate: '发布日期',
  PCMStatus: '监控状态',

  PPPosition: '任企业主要管理人员',
  PPLegalPerson: '担当法人',
  PPShareholder: '企业股东',
  PPLegalRisk: '司法风险',

  PUnaudited: '未审核',
  PBlacklist: '是我的客户',
  PNonBlacklist: '不是我的客户',
  Recheck: '复核',
  RecheckPass: '复核通过',
  RecheckNotPass: '复核不通过',
  RecheckResult: '复核结论',
  RecheckPeople: '复核人',
  RecheckTime: '复核日期',
  Pass: '通过',
  NotPass: '不通过',
  ExportPDF: '导出PDF',
  AddRemark:'添加备注',
  InputRemark:'请输入备注信息',
  RemarkMessage:'备注信息',
  Submit:'提交',
  RemarkIsNotNull:'备注不能为空!',
  PSequence: '流水号',
  PQueriedDate: '查询日期',
  PNationality: '所属国籍',
  PCountryRegion: '所属国家/地区',
  PAuditStatus: '审核',
  PAuditPersonal: '审核人',
  PAuditType: '识别方式',

  PAddMonitor: '添加监控',

  PersonalDiagram: '企业关联人智能图谱',

  CompanyInvestmentDiagram: '企业对外投资智能图谱',
  CIDCompany: '企业名称',
  CIDLegalPerson: '法人代表',
  CIDUniformSocialCreditCode: '统一社会信用代码',
  InstitutionRegistNum: '机构注册号',
  CIDBusinessCode: '注册号',
  CIDStatus: '企业状态',
  directOrIndirectHolds: '直接或间接持有',
  NotBenificialNoPath: '该股东不是受益所有人或实际控制人，暂不显示投资控制路径',

  ModelEnterpriseInformation: '投资企业信息',
  ModelSubscribedCapital: '认缴出资额(万元)',
  ModelINSTO: '出资比例',

  naturaPersonalDiagram: '自然人对外投资智能图谱',

  companyCenterplaceholder: '请输入监控企业名称',
  CompanyNameplaceholder: '请输入企业名称',
  NaturalNameplaceholder: '请输入自然人姓名',
  EnterpriseAssociateplaceholder: '请输入企业关联人名称',
  UserNameplaceholder: '请输入用户或实体详细名称',
  financialMonitorPlaceholder: '请输入已申请财务数据的企业名称',

  NewMonitor: '添加企业',
  // 财务报表
  Units: '单位：元',
  BusiIncome: '营业收入',
  BusiProfit: '营业利润',
  AccountReceivable: '应收账款',
  TotalProfit: '利润总额',
  TotalLiablity: '负债合计',
  NetProfitsExcludePL: '净利润（不含少数损益）',
  TotalCurrentLiability: '流动负债合计',
  NetProfitsDeductingPL: '扣除非经常性损益后净利润',
  TotalNCurrentLiablities: '非流动负债合计',
  IncomeTax: '所得税',
  TaxPayable: '应交税费',

  ExcessiveRiskShareholder: '疑似高风险干系人',

  // 面包屑导航
  Home: '首页',
  FuzzySearch: '企业模糊查询',
  StockDetail: '股权首页',
  WorldCheckFuzzySearch: '黑名单模糊查询',
  WCBasicInfo: '黑名单基本信息',
  WCMoreInfo: '黑名单更多信息',
  RiskReason: '风险原因',
  BenefitMap: '受益人图谱',
  AbroadFuzzySearch: '境外企业模糊查询',
  AbroadStockDetail: '境外企业首页',
  // 综合风险begin
  WaitPersonalRisk: '个人风险查询后续开放，敬请期待',
  Click: '点击查看',
  // 银保/证监会处罚弹窗
  IRCPunishment: '银保/证监会处罚',
  penaltyDecisionNumber: '处罚决定书文号',
  penalInstrumentTitle: '处罚文书标题',
  penalInstrumentName: '处罚文书名称',
  PunishmentAgency: '处罚机关',
  PublishedDate: '发布日期',
  Party: '当事人处罚',
  Object: '处罚对象',
  PunishClass: '处罚方式',
  Fine: '罚款金额（元）',
  PnealtyGround: '处罚依据',
  PenaltyAbstract: '事件摘要',
  PenaltyDetail: '处罚详情',
  SourceLink: '原文链接',
  Source: '来源',
  Operator: '操作人',
  WhetherToHit: '是否命中',

  // 工商行政处罚弹窗
  IndustryCommercePunish: '工商行政处罚',
  IllegalTypes: '违法种类',
  PunishmentTypes: '处罚种类',
  DecideDate: '决定日期',
  NoRelatedContent: '暂无相关内容',

  // 开庭&立案信息
  FileInfo: '立案信息',
  sessionInfo: '开庭公告',
  CaseNumber: '案号',
  Plaintiff: '原告',
  Defendant: '被告',

  // 裁判文书
  Trial: '裁判文书',
  DocumentNumber: '文书案号',
  CaseType: '文书类型',
  CaseContent: '文书内容',
  ObjectionContent: '异议内容',
  ObjectionTime: '提出异议时间',

  // 经营异常
  Exception: '经营异常',
  IncludeDate: '列入异常日期',
  DecisionAuthority: '列入决定机构',
  RemoveDate: '列出日期',
  RemoveAuthority: '列出决定机构',
  ExceptionReason: '列入原因',
  RemoveReason: '列出原因',

  // 股权冻结
  FrozenNumber: '冻结文号',
  FrozenBalance: '冻结资金',
  PenaltyAuthority: '冻结机关',
  FrozenStartDate: '冻结起始日期',
  FrozenEndDate: '冻结截至日期',
  StockUnfrozen: '股权解冻',
  UnfrozenNumber: '解冻文号',
  PunishAuthority: '解冻机关',
  UnfrozenDate: '解冻日期',
  UnfrozenContent: '解冻说明',

  AdministrativePenalty: '行政处罚',
  PunishmentDate: '处罚日期',
  DecisionNumber: '决定文书号',
  PunishmentContent: '处罚内容',
  Operation: '操作',
  Edit: '编辑',

  Judicial: '司法协助',
  JudicialCase: '案件名称',
  JudicialDateIssue: '发布时间',
  JudicialCaseNumber: '案件编号',
  JudicialStatus: '案件状态',
  JudicialPersonbeExecued: '被执行人',
  JudicialExecutiveCourt: '执行法院',
  JudicialOperation: '操作',

  // 股权出质
  EquityPledge: '股权出质',
  EPRegistrationNumber: '登记编号',
  EPMortgagor: '出质人',
  EPPawnee: '质权人',
  EPPledgeAmount: '质押金额',
  EPDateRegistration: '登记日期',
  EPStatus: '状态',
  PledgorBalance: '出质股权数额',
  StockPawnAlter: '出质变更',
  StockPawnCancellation: '出质注销',
  PublishmentContent: '公告内容',

  // 动产抵押
  ChattelMortgage: '动产抵押',
  CMRegistrationNumber: '登记编号',
  CMMortgagee: '抵押权人',
  Pawn: '抵押物',
  CMMortgages: '抵押物名称',
  CMOwnership: '所有权或使用权归属',
  PawnInfo: '抵押物详情',
  CMAuthority: '登记机关',
  CMStatus: '状态',
  ClaimAmount: '被担保债权数额',
  RegistrationDate: '登记日期',
  PublicDate: '公示日期',
  MortgageregList: '登记信息',
  BoneType: '被担保债券种类',
  Scope: '担保范围',
  BeginDate: '起始日期',
  EndDate: '截止日期',
  Mortgageper: '名称',
  IDKind: '证件类型',
  IDNumber: '证件号码',
  Remark: '备注',
  MortgageAlter: '抵押变更',
  AlterDate: '变更日期',
  AlterContent: '变更内容',
  MortgageCancellation: '抵押注销',
  CancellationDate: '注销日期',
  CancellationReason: '注销原因',

  IntellectualPropertyPledge: '知识产权出质',
  IPPRegistrationNumber: '登记编号',
  IPPProperty: '产权名称',
  IPPMortgagor: '出质人',
  IPPPawnee: '质权人',
  IPPDateRegistration: '登记日期',
  IPPStatus: '状态',

  // 严重违法失信
  Discredit: '严重违法失信',
  IncludeDocumentNumber: '列入文号',
  RemoveDocumentNumber: '移除文号',
  IllegalAndDiscreditEnterprise: '严重违法失信企业',
  IADECategory: '失信类别',
  IADEAuthority: '列入决定机构',
  IADEAuthorityRemove: '移除决定机构',
  IADEDateAdded: '列入日期',
  IADEDateRemoved: '移出日期',
  Cause: '原因',

  DDishonestCivilDebtor: '失信被执行人',
  ExecutionCaseNumber: '执行案号',
  DExecutionBasisNumber: '执行依据文号',
  DExecutionBasisUnit: '做出执行依据单位',
  DDishonestyTime: '认定失信时间',
  ReleaseTime: '发布时间',

  RestrictingHighConsumption: '限制高消费被执行人',
  Name: '姓名',
  ExecutiveCourt: '执行法院',
  CauseOfAction: '案由',
  filingTime: '立案时间',

  RestrictingExitExecutors: '限制出境被执行人',
  ReferenceNumber: '案号',
  BorderControlDate: '边控日期',
  OccurrenceTime: '发生时间',
  BorderControlMeasures: '边控措施',

  DeadbeatInfor: '老赖信息',
  PublishedTime: '公布时间',

  // 税务违法
  TaxIllegalInformation: '税务违法',
  ClientName: '当事人名称',
  CompetentTaxAuthorities: '主管税务机关',
  InspectionInstrumentsNumber: '稽查文书编号',
  TreatDecisiondate: '处罚决定日期',
  LimitedFulfilmentDate: '处理处罚限定履行日期',
  PerformDate: '处罚履行时间',
  TaxpayerStatus: '纳税人状态',
  IllegalType: '违法行为种类',
  OtherDetails: '其他详情',
  IllegalMethod: '违法手段',
  TaxPaid: '实缴税款',
  TaxUnpaid: '未缴税款',
  Penalty: '违约金',
  ActualPerformDate: '实际履行时间',
  // 综合风险end

  // 企业舆情
  PublicStatement: '企业舆情',
  ReportManager: '报告管理',
  Favorite: '收藏',
  cancelCollect: '取消收藏',
  collectSuccess: '收藏成功',
  cancelSuccess: '取消收藏成功',
  Share: '分享',
  Present: '今天',
  SevenDay: '近7天',
  Month: '近1个月',
  ThreeMonth: '近3个月',
  HalfYear: '近6个月',
  Total: '总计',
  ChooseType: '请选择正/负面',
  ChoosePositive: '正面',
  ChooseNegative: '负面',
  ChooseNeutral: '中性',
  PleaseChooseDateScope: '请选择日期范围',
  PleaseChooseKeyEvents: '请选择关键事件',
  NoResultMatch: '没有匹配到结果',
  Time: '时间',
  Condition: '条件',
  OR: '或',
  Search: '查询',
  Clear: '清除',
  tooLongTimeSpan: '时间跨度不得超过365天',

  // 财务报表begin
  WaitSubscribedReportHint: '您已订阅该企业报表数据，请耐心等待。',
  UpdateFinancialData: '更新财务数据',
  BalanceSheet: '资产负债表',
  CurrentAssets: '流动资产',
  Currency: '货币资金',
  NetAccountReceivable: '应收账款净额',
  NetDeposit: '存货净额',
  TotoalCurrentAssets: '流动资产合计',
  LongTermInvestment: '长期投资',
  LongTermEquityInvestment: '长期股权投资',
  FixedAssets: '固定资产',
  OriginalValue: '固定资产原价',
  LessAccumulatedDepreciation: '减：累计折旧',
  NetFixedAssets: '固定资产净额',
  TotalFixedAssets: '固定资产合计',
  InvisibleDeferredAssets: '无形及递延资产',
  LongtermPrepaidExpenses: '长期待摊费用',
  IntangiblesOtherAssets: '无形及其他资产合计',
  TotalAssets: '资产合计',
  CurrentLiabilities: '流动负债',
  ShorttermBorrowings: '短期借贷',
  NotesPayable: '应付票据',
  AccountsPayable: '应付账款',
  TaxesPayable: '应交税金',
  TotalCurrentLiabilities: '流动负债合计',
  LongtermLiabilities: '长期负债',
  LongtermPayable: '长期应付款',
  TotalLiabilities: '负债合计',
  StockholdersEquity: '股东权益',
  NetPaidCapital: '实收资本净额',
  Undistributedprofits: '未分配利润',
  TotalOwenerEquity: '所有权益合计',
  TotalLiabilitiesEquity: '负债及所有者权益总计',

  IncomeStatement: '经营利润表',
  RevenuefromMainOperation: '主营业务收入',
  NetSales: '产品销售净额',
  LessOperationExpense: '减：经营费用',
  LessMainOperationCost: '减：主营业务成本',
  SalesTax: '销售税金及附加',
  OperationCosts: '运营成本',
  GAExpense: '管理费用',
  FinanceExpense: '财务费用',
  ProfitfromOperation: '营业利润',
  ProfitbeforeTax: '利润总额',
  LessIncomeTax: '减：所得税',
  NetProfit: '净利润',
  TotalCompositeIncome: '综合收益总额',
  SubscribeFinancialHint: '该企业为非上市企业，财务报表数据获取需要T+3天的时间，并且需要收取一定的费用，确定是否申请？',
  Sumbit: '继续申请',
  // 财务报表end

  // 知识产权begin
  SummaryStatistics: '汇总信息',
  Patent: '专利信息',
  Trademark: '商标信息',
  Copyright: '软件著作权',
  SummaryDetails: '详情介绍',
  PatentNumber: '专利号',
  PatentName: '专利名称',
  IPCAT: '类型',
  ApplicationDate: '申请日期',
  RegistrationNumber: '注册号',
  RegistrationName: '专利名称',
  CheckinNumber: '登记号',
  CopyrightName: '著作权名称',
  Inventor: '发明人',
  LegalStatus: '法律状态',
  Applicant: '申请人',
  Agency: '代理机构',
  PatentCAT: '专利类型',
  PatentStatus: '专利状态',
  ApplyNumber: '申请号',
  OpenNumber: '公开号',
  PublishmentDate: '公开日期',
  Summary: '摘要信息',
  Inset: '摘要附图',
  TrademarkInfo: '企业商标信息',
  TrademarkStatus: '商标状态',
  ProductOrService: '商品/服务项目',
  Term: '使用期限',
  TrademarkImage: '商标图片',
  TrademarkType: '商标类型',
  to: '至',
  Abbr: '软件简称',
  Version: '软件版本',
  Owner: '著作权人',
  CopyrightType: '著作权类型',
  FinishDate: '完成日期',
  // 知识产权end

  // 图谱弹窗begin
  GeneralInformation: '公司基本信息',

  // 图谱弹窗end

  // 个人监控列表and企业监控列表
  normal: '正常',
  Expired: '已过期',

  // 境外企业首页 begin
  // 证券信息
  StockExchange: '证券交易所',
  CountryOfExchange: '交易所所在国家',
  IsTheMostImportantExchange: '是否是最重要的交易所',

  // 基本信息
  IDType: '证件号类别',
  ApprovalDate: '审核日期',
  RegistrationForm: '注册形式',
  RegisteredAddress: '注册地址',
  NumberOfStaff: '员工数量',
  Trade: '行业',
  AffiliatingArea: '所属地区',
  Postcode: '邮编编码',
  Facsimile: '传真',
  URL: '网址',
  WhetherImportersOrExporters: '是否进出口商',

  // 高管信息
  ExecutivesInfo: '高管信息',

  // 股东信息
  IsBeneficiary: '是否受益所有人',
  fivePerDataOnly: '上市公司仅展示大于等于5%的股东数据',

  // 财务信息
  FinancialInfor: '财务信息',
  ReportingDeadline: '财报截止时间',
  ReportingCycle: '财报周期',
  PropertyScope: '财务范围',
  DataDetail: '财务数据',
  MonetaryUnit: '货币单位',
  // 境外企业首页 end

  // 企业数据批量处理 start
  DataBatchProcess: '企业数据批量处理',
  ListCleaning: '企业名单清洗',
  BatchDownload: '企业股权/受益人批下载',

  // 名单管理 start
  ListManagement: '名单管理',
  ListUpdateOverview: '名单更新概况',
  timesUpdatedToday: '今日更新记录/次数',
  timesUpdatedThisMonth: '本月更新记录/次数',
  timesUpdatedTotal: '累计更新记录/次数',
  ListDownload: '名单数据下载',
  UpdateTime: '更新时间',
  Search: '查询',
  Reset: '重置',
  FileName: '文件名称',
  UpdateRecord: '更新记录',
  Operate: '操作',
  Operator: '操作人员',
  SoFar: '至今',
  Download: '下载',
  YearMonthDay: '年/月/日',   //待确认

  // 黑名单详情-新闻来源
  NewsList: '新闻来源',
  No: '序号',
  LinkAddress: '链接地址',
  Mark: '标记',
  Select: '请选择',
  ValidLink: '有效链接',
  InvalidLink: '无效链接',
  LowAliasName: '低质量别名',
  AlternativeName: '非正规拼写',
  lowAliasName: '低质量别名',
  alternativeName: '非正规拼写',
  personage: '个人',
  organization: '机构',
  yes: '是',
  no: '否',
  mainData: '主要名称',
  Sizer: '筛选器',
  chooseTaskName: '请输入任务名称',
  chooseAuditStatus: '审核状态',
  chooseUpdateTime: '更新日期',
  addTaskSuccess: '任务增加成功',
  postfix: '后缀',
  registDate: '注册日期',
  Last24Hours: '过去24小时',
  LastOneWeek: '过去1周',
  LastOneMonth: '过去1个月',
  SelectTheDataToExport: '请选择要导出的数据',
  ServerException: '服务调用异常',
  SetPassword: '请设置密码',
  PasswordNotNull: '密码不能为空',
  PasswordError: '密码必须为6-16位，数字、字母或者符号，特殊符号(! $ # @ _)',
  HindMessage: '密码必须为6-16位，数字、字母或者符号，特殊符号(! $ # @ _)',
  ReportStatus: '报告状态',
  ReportType: '报告类型',
  ok: '确定',
  ok1: '知道了',
  IsReportDelete: '尽调报告删除后不可恢复，请确认是否删除?',
  ReportConpony: '尽调报告正在生成中，你可以到【个人中心-报告管理】模块中查看',
  ReportDelete: '报告删除',
  DocPass: '文档密码',
  LookPass: '密码查看',
  DownFiled: '该功能需要付费，如需开通请联系GTN客服。',
  SerialNoList: '返回流水列表',
  RecordCount: '记录条数',
  OperateTime: '操作日期',
  RollID: '名单ID',
  InputSerialNo: '请输入要查询的流水号',
  UpdataSuccess: '更新成功'
}



// WEBPACK FOOTER //
// ./src/assets/i18n/zh.js